<template>
    <v-dialog v-if="user === undefined" v-model="dialog" transition="dialog-bottom-transition" max-width="500px" @input="onDialogToggle">
        <template v-slot:activator="{ on, attrs }">
            <a v-bind="attrs" v-on.prevent="on" class="reset" style="margin-bottom: 8px; display: block;"> {{ $t('Zapomněl/a jsi heslo?') }}</a>
        </template>
        <v-card dark class="resetdialog">
            <v-card-title>{{ $t('Obnova hesla') }}</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="E-mail" v-model="email" type="email" autocomplete="email" outlined required :disabled="sent" :error-messages="emailError" @keyup.enter="reset()">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" v-if="errorMessage">
                            <v-alert type="error" dense text class="mb-0">{{ $te(errorMessage) ? $t(errorMessage) : errorMessage }}</v-alert>
                        </v-col>
                        <v-col cols="12" v-if="sent">
                            <v-alert type="success" dense text class="mb-0">{{ $t('Dočasné heslo jsme poslali na váš e-mail. Přihlaste se jím a pak si ho v nastavení změňte.') }}</v-alert>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="sent" color="green" text @click="dialog = false">
                    {{ $t('Zavřít') }}
                </v-btn>
                <v-btn v-else color="green" text @click="reset()" :loading="loading">
                    {{ $t('Odeslat') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
    data() {
        return {
            dialog: false,
            sent: false,
            loading: false,

            email: "",

            emailError: "",
            errorMessage: "",
        };
    },

    computed: {
        user() {
            return this.$store.state.user;
        },
    },

    watch: {
        email() {
            this.emailError = "";
            this.errorMessage = "";
        },
    },

    methods: {
        onDialogToggle(open) {
            // Opening the dialog starts from a clean form; a finished reset must not leak into the next one.
            if (open && this.sent) this.clear();
        },

        clear() {
            this.sent = false;
            this.loading = false;
            this.emailError = "";
            this.errorMessage = "";
        },

        async reset() {
            if (this.loading) return;

            this.email = (this.email || "").trim();
            this.errorMessage = "";

            if (!this.email) {
                this.emailError = this.$t("Zadejte prosím svůj e-mail.");
                return;
            }

            if (!EMAIL_PATTERN.test(this.email)) {
                this.emailError = this.$t("Zadejte prosím platnou e-mailovou adresu.");
                return;
            }

            this.loading = true;
            const result = await this.$store.dispatch("resetPassword", { email: this.email });
            this.loading = false;

            if (!result.ok) {
                this.errorMessage = result.message;
                return;
            }

            this.sent = true;
        },
    },
};
</script>

<style>
a.reset {
    color: #fff !important;
    text-decoration: underline;
}
.resetdialog {
    background-color: #1e1e1e !important;
}
</style>